<template>
  <div v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {};
</script>
<style>
[v-cloak] {
  display: none;
}
.small {
  font-size: 0.8rem;
}
</style>
